
import { useScenario} from "../../contexts/ScenarioContext"

import RevealTable from "../RevealTable"

const AirwayTabContent = () => {
    const { airwayFindings } = useScenario()
     
 
    return (
            <RevealTable
                title="Airway"
                category="airway"
                headings={["Assessments", "Current Value"]}
                rows={airwayFindings}
            />
    )
}

export default AirwayTabContent